var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.608,
    height: 20.608,
    viewBox: "0 0 20.608 20.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(-673.65 -629.579)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_757",
    "data-name": "Line 757",
    x1: 20.608,
    transform: "translate(673.65 639.883)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_758",
    "data-name": "Line 758",
    y2: 20.608,
    transform: "translate(683.953 629.579)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 1.417
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.aec565f83eaa7f977deb72ef6223a657.svg";
export { ForwardRef as ReactComponent };